<template>
  <b-container id="the-analyze">
    <b-row no-gutters class="container-analyze">
      <b-col cols="4" class="view-analyze" v-show="isListViewShown">
        <b-row no-gutters class="tab-bar">
          <div class="tab-container">
            <div
              v-for="tab in tabs"
              v-bind:key="tab.type"
              class="tab"
              v-bind:class="{ active: tab.active }"
              v-on:click="$_setActiveTabType(tab.type)"
            >
              {{ tab.name }}
            </div>
          </div>
        </b-row>
        <b-row no-gutters class="tab-content">
          <!-- データマップ -->
          <analyze-data
            v-if="activeTabType === TAB_CONTENT_TYPE.DATA"
            v-bind="params"
            v-bind:layer-type="dataMap.layerType"
            v-bind:legend="legend"
            v-bind:visible="visible"
            v-bind:is-analyze-shown="isAnalyzeShown"
            v-bind:max-hours="maxHours"
            v-bind:max-users-count="maxUsersCount"
            v-bind:has-hidden-users="hasHiddenUsers"
            v-bind:is-loading="isLoading"
            v-on="paramsListeners"
            v-on:analyze-show="$_setAnalyzeShown(true)"
            v-on:analyze-hide="$_setAnalyzeShown(false)"
          />
          <!-- 軌跡マップ -->
          <analyze-track
            v-if="activeTabType === TAB_CONTENT_TYPE.TRACK"
            v-bind="params"
            v-bind:legend="legend"
            v-bind:visible="visible"
            v-bind:is-analyze-shown="isAnalyzeShown"
            v-bind:max-hours="maxHours"
            v-bind:max-users-count="maxUsersCount"
            v-bind:has-hidden-users="hasHiddenUsers"
            v-bind:is-loading="isLoading"
            v-on="paramsListeners"
            v-on:analyze-show="$_setAnalyzeShown(true)"
            v-on:analyze-hide="$_setAnalyzeShown(false)"
          />
          <!-- 過去位置再生 -->
          <analyze-location-play
            v-if="activeTabType === TAB_CONTENT_TYPE.PLAY"
            v-bind="params"
            v-bind:legend="legend"
            v-bind:visible="visible"
            v-bind:is-analyze-shown="isAnalyzeShown"
            v-bind:max-hours="maxHours"
            v-bind:max-users-count="maxUsersCount"
            v-bind:has-hidden-users="hasHiddenUsers"
            v-bind:is-loading="isLoading"
            v-on="paramsListeners"
            v-on:analyze-show="$_setAnalyzeShown(true)"
            v-on:analyze-hide="$_setAnalyzeShown(false)"
          />
        </b-row>
      </b-col>
      <b-col v-bind:cols="viewCols.right" class="view-map">
        <loading-mask v-bind:is-loading="isLoading">
          <!-- 地図 -->
          <map-control
            ref="map-control"
            id="analyze-map-control"
            v-bind="$store.getters.mapControlBinds"
            v-bind:id-prefix="'analyze-'"
            v-bind:reactive-render="!isModalOverlaid"
            v-bind:layer-renderers="renderers"
            v-bind:layer-menu-data="layerMenuData"
            v-bind:onIfieldApiError="handleApiError"
            v-on:indoor-level-selected="setActiveIndoorLevelId"
            v-on:indoor-building-reset="unselectedBuilding"
            v-on:map-control-initend="$_onMapInitEnd"
            v-on:menu-layers-visible-changed="$_onLayerMenuVisibleChanged"
          >
            <template v-slot:map-left-top>
              <div class="map-left-top-container">
                <analyze-layer-type-selector
                  v-if="isDataLayerSelectable"
                  class="map-control-ui"
                  v-model="dataMap.layerType"
                  v-bind:options="dataMap.options"
                />
                <map-indoor-building-button
                  class="map-control-ui"
                  v-bind:indoorBuilding="
                    $store.getters['mapIndoor/activeIndoorBuilding']
                  "
                  v-on:reset-click="
                    $store.dispatch('mapIndoor/unselectedBuilding')
                  "
                />
              </div>
              <!-- リスト切り替えタブ -->
              <list-view-toggle-tab
                v-model="isListViewShown"
                v-bind:listViewCols="viewCols.left"
                v-bind:idPrefix="'analyze'"
                class="map-control-ui"
                v-on:listview-toggletab-toggled="$_toggleListViewShown"
              />
            </template>
            <template v-slot:default="{ currentMapComponent, clientRect }">
              <!-- 再生コントローラー -->
              <location-play-controller
                v-if="activeTabType === TAB_CONTENT_TYPE.PLAY && isAnalyzeShown"
                class="location-play-controller"
                v-bind:from="params.from"
                v-bind:to="params.to"
                v-on:mounted="$_setPlayController"
              />
              <!-- ツールチップ -->
              <map-popup-track-point
                v-if="
                  activeTabType === TAB_CONTENT_TYPE.TRACK && isAnalyzeShown
                "
                v-bind:current-map-component="currentMapComponent"
                v-bind:map-client-rect="clientRect"
                v-bind:feature="track.hoverFeature"
              />
            </template>
          </map-control>
        </loading-mask>
      </b-col>
    </b-row>
    <template v-if="isAnalyzeShown">
      <!-- データマップレイヤー管理 -->
      <analyze-data-layer-manager
        v-if="activeTabType === TAB_CONTENT_TYPE.DATA"
        v-bind="paramsForLayerManager"
        v-bind:indoor-level-id="activeIndoorLevelId"
        v-bind:layer-type="dataMap.layerType"
        v-bind:visible="visible"
        v-bind:highlighted-user-id="highlightedUserId"
        v-on="layerManagerListeners"
      />
      <!-- 軌跡レイヤー管理 -->
      <analyze-track-layer-manager
        v-if="activeTabType === TAB_CONTENT_TYPE.TRACK"
        v-bind="paramsForLayerManager"
        v-bind:indoor-level-id="activeIndoorLevelId"
        v-bind:visible="visibleForTrack"
        v-bind:setting="settingForTrack"
        v-bind:highlighted-user-id="highlightedUserId"
        v-on="layerManagerListeners"
      />
      <!-- 位置再生レイヤー管理 -->
      <analyze-location-play-layer-manager
        v-if="activeTabType === TAB_CONTENT_TYPE.PLAY"
        v-bind="paramsForLayerManager"
        v-bind:indoor-level-id="activeIndoorLevelId"
        v-bind:controller="play.controller"
        v-bind:visible="visible"
        v-bind:highlighted-user-id="highlightedUserId"
        v-on="layerManagerListeners"
      />
    </template>
    <place-detail
      ref="place-detail"
      v-on:place-searchreport-click="$_showReport"
      v-on:place-searchuser-click="$_showMember"
      v-on:hide-modal="$_onHidePlaceDetail"
    />
    <!-- モーダル重畳検知 -->
    <modal-overlay-detector
      v-on:is-modal-overlaid-changed="$_onModalOverlayChanged"
    />
  </b-container>
</template>

<script>
import ListViewToggleTab from '@/components/AppListViewToggleTab.vue'
import BvModalOverlayDetector from '@/components/AppBvModalOverlayDetector.vue'
import AnalyzeData from '@/components/analyze/AppAnalyzeData.vue'
import AnalyzeTrack from '@/components/analyze/AppAnalyzeTrack.vue'
import AnalyzeLocationPlay from '@/components/analyze/AppAnalyzeLocationPlay.vue'
import AnalyzeDataLayerManager from '@/components/analyze/AppAnalyzeDataLayerManager.vue'
import AnalyzeTrackLayerManager from '@/components/analyze/AppAnalyzeTrackLayerManager.vue'
import AnalyzeLocationPlayLayerManager from '@/components/analyze/AppAnalyzeLocationPlayLayerManager.vue'
import AnalyzelayerTypeSelector from '@/components/analyze/AppAnalyzeLayerTypeSelector.vue'
import LocationPlayController from '@/components/analyze/AppLocationPlayController.vue'
import MapPopupTrackPoint from '@/components/analyze/AppMapPopupTrackPoint.vue'
import PlaceDetail from '@/views/ThePlaceDetail.vue'
import { MapIndoorBuildingButton } from 'ifield-core-components'
import { mapState, mapGetters } from 'vuex'
import { useHandleApiError } from '@/composables/UseHandleApiError.js'
import { useMapIndoorStore } from '@/composables/map/UseMapIndoorStore'
import { useStoreAnalyzeTrackSetting } from '@/composables/UseStoreAnalyzeTrackSetting.js'
import ModalUtil from '@/js/util/ModalUtil.js'

/**
 * タブコンテンツの種類
 */
const TAB_CONTENT_TYPE = {
  DATA: 'data',
  TRACK: 'track',
  PLAY: 'play',
}

/**
 * visibleの初期値
 */
const INITIAL_VISIBLE = {
  all: true,
  geometry: true,
  user: true,
}

export default {
  name: 'TheAnalyze',
  components: {
    'analyze-data': AnalyzeData,
    'analyze-track': AnalyzeTrack,
    'analyze-location-play': AnalyzeLocationPlay,
    'analyze-data-layer-manager': AnalyzeDataLayerManager,
    'analyze-track-layer-manager': AnalyzeTrackLayerManager,
    'analyze-location-play-layer-manager': AnalyzeLocationPlayLayerManager,
    'analyze-layer-type-selector': AnalyzelayerTypeSelector,
    'location-play-controller': LocationPlayController,
    'map-popup-track-point': MapPopupTrackPoint,
    'map-indoor-building-button': MapIndoorBuildingButton,
    'list-view-toggle-tab': ListViewToggleTab,
    'modal-overlay-detector': BvModalOverlayDetector,
    'place-detail': PlaceDetail,
  },
  props: {
    /**
     * 初期タブタイプ
     */
    initialType: {
      type: String,
      default: 'data',
    },
    /**
     * 初期ユーザー
     */
    initialUsers: {
      type: Array,
      default: null,
    },
  },
  setup(props, context) {
    const { handleApiError } = useHandleApiError(props, context)
    const { unselectedBuilding, setActiveIndoorLevelId } = useMapIndoorStore()
    const { restoreAnalyzeTrackSettingFromLocalStorage } =
      useStoreAnalyzeTrackSetting()
    return {
      handleApiError,
      unselectedBuilding,
      setActiveIndoorLevelId,
      restoreAnalyzeTrackSettingFromLocalStorage,
    }
  },
  data: function () {
    return {
      /**
       * ページが表示されている場合はtrue
       * keep-alive で保持されるため、非表示でも破棄されない
       * @type {Boolean}
       */
      isViewActive: true,
      // アクティブタブ
      activeTabType: this.initialType,
      // パラメータ
      params: {
        from: null,
        to: null,
        users: (this.initialUsers || []).map((u) => ({ ...u, type: 'user' })),
        indoorBuildings: null,
      },
      // 最大指定期間(時間)
      maxHours: 24,
      // 最大ユーザー数
      maxUsersCount: 30,
      // 分析表示中はtrue
      isAnalyzeShown: false,
      // データマップで使用する情報
      dataMap: {
        // 選択肢
        options: [],
        // レイヤー種類
        layerType: 'heatmap',
      },
      // 軌跡マップで使用する情報
      track: {
        // hover中地物
        hoverFeature: null,
      },
      // 位置再生で使用する情報
      play: {
        // LocationPlayControllerのインスタンス
        controller: null,
      },
      // レンダラー
      renderer: null,
      // 分析レイヤーのレイヤーメニューデータ
      analyzeLayerMenuData: null,
      // レイヤー表示状態
      visible: { ...INITIAL_VISIBLE },
      // 凡例用データ
      legend: {},
      // ロード中の場合はtrue
      isLoading: false,
      // ホバー中のユーザーID
      highlightedUserId: null,
      // リストビューを表示する場合true
      isListViewShown: true,
      // モーダルが重畳している場合はtrue
      isModalOverlaid: false,
    }
  },
  computed: {
    ...mapGetters('map', ['layerRenderers']),
    ...mapGetters('mapLayer', ['mapLayers', 'clickedPlace']),
    ...mapGetters('map/layerMenu', {
      /**
       * storeにあるレイヤーメニューデータ
       * @type {Array.<Object>}
       */
      storedLayerMenuData: 'layerMenuData',
    }),
    ...mapState('mapIndoor', ['activeIndoorLevelId']),
    ...mapState('indoorBuilding', ['indoorBuildings']),
    ...mapState('analyzeTrack', [
      'showPoint',
      'showLine',
      'showStart',
      'showEnd',
      'pointRadius',
      'pointLineWidth',
      'lineWidth',
    ]),
    /**
     * タブ種類定義
     * @type {Object}
     */
    TAB_CONTENT_TYPE: function () {
      return TAB_CONTENT_TYPE
    },
    /**
     * タブ定義
     * @type {Array.<Object>}
     */
    tabs: function () {
      return [
        {
          type: TAB_CONTENT_TYPE.DATA,
          name: this.$t('theAnalyze.type.data'),
          active: this.activeTabType === TAB_CONTENT_TYPE.DATA,
        },
        {
          type: TAB_CONTENT_TYPE.TRACK,
          name: this.$t('theAnalyze.type.trajectory'),
          active: this.activeTabType === TAB_CONTENT_TYPE.TRACK,
        },
        {
          type: TAB_CONTENT_TYPE.PLAY,
          name: this.$t('theAnalyze.type.play'),
          active: this.activeTabType === TAB_CONTENT_TYPE.PLAY,
        },
      ]
    },
    /**
     * データレイヤー選択可能時true
     * @type {Boolean}
     */
    isDataLayerSelectable: function () {
      return this.activeTabType === TAB_CONTENT_TYPE.DATA && !!this.renderer
    },
    /**
     * 組織選択分もユーザーに展開したユーザーパラメータ
     * @type {Object[]}
     */
    extendedParamUsers: function () {
      if (!this.params.users) return []
      const userMap = new Map()
      // 同一ユーザーがユーザー選択と組織選択の両方に含まれることがあるため、
      // 後から追加された値で名称・ロールIDを欠落させないようマージする
      const mergeUser = ({ id, name, roleId }) => {
        const stored = userMap.get(id)
        userMap.set(id, {
          id,
          name: name || stored?.name || null,
          roleId: roleId ?? stored?.roleId ?? null,
        })
      }
      for (const item of this.params.users) {
        const { type, id, users, name, roleId } = item
        if (type === 'user') {
          mergeUser({ id, name, roleId })
        } else if (type === 'organization') {
          users.forEach((u) => mergeUser(u))
        }
      }
      return [...userMap.values()]
    },
    /**
     * LayerManager への binding 用 params
     * @type {Object}
     */
    paramsForLayerManager: function () {
      return {
        ...this.params,
        users: this.extendedParamUsers,
      }
    },
    /**
     * deck.glレンダラー
     * @type {Array.<Function>}
     */
    renderers: function () {
      if (this.renderer) {
        return [...this.layerRenderers, this.renderer.render]
      } else {
        return this.layerRenderers
      }
    },
    /**
     * レイヤーメニュー用データ
     * @type {Array.<Object>}
     */
    layerMenuData: function () {
      if (!this.analyzeLayerMenuData) {
        return this.storedLayerMenuData
      }
      return [...this.analyzeLayerMenuData, ...this.storedLayerMenuData]
    },
    /**
     * パラメータ変更リスナー
     * @type {Object}
     */
    paramsListeners: function () {
      return {
        'from-changed': (value) => {
          this.params.from = value
        },
        'to-changed': (value) => {
          this.params.to = value
        },
        'users-changed': (value) => {
          this.params.users = value
        },
        'indoor-buildings-changed': (value) => {
          this.params.indoorBuildings = value
          if (!value || !value.length) {
            this.$store.dispatch('mapIndoor/unselectedBuilding')
          } else if (value.length === 1) {
            this.$store.dispatch('mapIndoor/changeIndoorBuilding', value[0])
          }
        },
        'user-visible-changed': (value) => {
          this.visible.user = value
        },
        'geometry-visible-changed': this.$_updateGeometryVisible,
        'user-hover-changed': (id) => {
          this.highlightedUserId = id
        },
      }
    },
    /**
     * レイヤーマネージャーのリスナー
     * @type {Object}
     */
    layerManagerListeners: function () {
      return {
        'is-loading-changed': this.$_updateLoading,
        'no-location-found': this.$_showNoLocationAlert,
        'renderer-changed': this.$_setAnalyzeRenderer,
        'geometry-visible-changed': this.$_updateGeometryVisible,
        'layer-menu-data-changed': this.$_setAnalyzeLayerMenuData,
        'legend-data-changed': this.$_setLegendData,
        'layer-options-created': this.$_setLayerOptions,
        'hover-feature-changed': this.$_setHoverFeature,
      }
    },
    /**
     * ビュー分割のcol数
     * @type {Object}
     */
    viewCols: function () {
      return this.isListViewShown
        ? { left: 4, right: 8 }
        : { left: 0, right: 12 }
    },
    /**
     * 非表示のユーザーが1人でもいる場合はtrue
     * @type {Boolean}
     */
    hasHiddenUsers: function () {
      if (typeof this.visible.user === 'boolean') {
        return !this.visible.user
      }
      if (typeof this.visible.user === 'object' && this.visible.user !== null) {
        return Object.values(this.visible.user).some((v) => !v)
      }
      return false
    },
    /**
     * 軌跡マップ用表示状態
     * @type {Object}
     */
    visibleForTrack: function () {
      return {
        ...this.visible,
        geometry: {
          line: this.showLine,
          point: this.showPoint,
          start: this.showStart,
          end: this.showEnd,
        },
      }
    },
    /**
     * 軌跡マップ用表示設定
     * @type {Object}
     */
    settingForTrack: function () {
      return {
        pointRadius: this.pointRadius,
        pointLineWidth: this.pointLineWidth,
        lineWidth: this.lineWidth,
      }
    },
  },
  created: function () {
    // 初期屋内状態の設定
    // マップレイヤー取得後でないとレイヤーの表示状態を更新出来ないため、取得を待つ
    // 初期化時だけでいいので1回処理したらwatchを解除する
    if (this.mapLayers.length) {
      this.$_initializeIndoorBuildingParam()
    } else {
      let unwatch = this.$watch('mapLayers', function () {
        this.$_initializeIndoorBuildingParam()
        unwatch()
      })
    }
    // 軌跡マップ表示設定読み込み
    this.restoreAnalyzeTrackSettingFromLocalStorage()
  },
  mounted: function () {
    // ビルの権限が無い or フロアが無い場合
    // wacherが検知する前にAppMapIndoorControllerの選択戻し処理が終わってしまい
    // watcherでは正常に地図側とのビル選択同期処理をトリガーできないため
    // イベントのコールバックで処理する
    this.$root.$on('indoor-building-changed', this.$_syncIndoorBuilding)
  },
  beforeDestroy: function () {
    this.$root.$off('indoor-building-changed', this.$_syncIndoorBuilding)
  },
  activated: function () {
    // 初回描画時は created / mounted で初期化済みなので何もしない
    if (this.isViewActive) return
    this.isViewActive = true
    this.$root.$on('indoor-building-changed', this.$_syncIndoorBuilding)
  },
  deactivated: function () {
    this.isViewActive = false
    // 表示していない間はビル選択の同期をしない
    this.$root.$off('indoor-building-changed', this.$_syncIndoorBuilding)
    // 開いたままのダイアログを閉じる
    ModalUtil.hideAllIn(this)
  },
  watch: {
    activeTabType: function () {
      this.$_setAnalyzeShown(false)
    },
    activeIndoorLevelId: function () {
      this.$_clear()
    },
    clickedPlace(value) {
      // Click された Feature が変更された
      // プレイス詳細ダイアログを表示する
      this.$log.debug('[clickedPlace] ', value)
      // 保持されている非表示のページでも watcher は動くので、表示中のページだけが開く
      if (value && this.isViewActive && !this.isModalOverlaid) {
        this.$_showPlaceDialog(value.properties.place_id)
      }
    },
  },
  methods: {
    /**
     * ビル選択を初期化する
     */
    $_initializeIndoorBuildingParam: function () {
      if (this.initialType === TAB_CONTENT_TYPE.DATA && !this.initialUsers) {
        // 初期propsが指定されいない場合は前の屋内状態を引き継がない
        this.$store.dispatch('mapIndoor/unselectedBuilding')
      } else if (this.$store.state.mapIndoor.indoorBuildings.length) {
        // 指定されていて屋内だった場合はstoreの値にしたがってパラメータを更新
        this.params.indoorBuildings =
          this.$store.state.mapIndoor.indoorBuildings
      }
    },

    /**
     * ビル選択を同期する
     * @param {Number} id 同期するビルID
     */
    $_syncIndoorBuilding: function (id) {
      if (!id) {
        this.params.indoorBuildings = null
      } else {
        const building = this.indoorBuildings.find((b) => b.id === id)
        this.params.indoorBuildings = building ? [building] : null
      }
    },

    /**
     * タブコンテンツ種類を設定する
     * @param {String} type 種類
     */
    $_setActiveTabType: function (type) {
      this.activeTabType = type
    },

    /**
     * 分析表示状態をセットする
     * @param {Boolean} value 表示状態
     */
    $_setAnalyzeShown: function (value) {
      this.isAnalyzeShown = value

      if (!value) {
        this.$_reset()
      }
    },

    /**
     * 表示をクリアする
     */
    $_clear: function () {
      this.isLoading = false
      this.renderer = null
    },

    /**
     * 表示をリセットする
     */
    $_reset: function () {
      this.$_clear()
      this.visible = { ...INITIAL_VISIBLE }
      this.$_setAnalyzeLayerMenuData(null)
      this.$_setLegendData({})
      this.$_setPlayController(null)
    },

    /**
     * 図形の表示状態更新
     * @param {Object} value 変更値
     */
    $_updateGeometryVisible: function (value) {
      this.visible.geometry = value
    },

    /**
     * 集計レイヤーのレンダラーをセットする
     * @param {Object} レンダラーオブジェクト
     */
    $_setAnalyzeRenderer: function (renderer) {
      if (this.isAnalyzeShown) {
        this.renderer = renderer
      }
    },

    /**
     * 集計レイヤーのレイヤーメニュー用データをセットする
     * @param {Array.<Object>} data レイヤーメニュー用データ
     */
    $_setAnalyzeLayerMenuData: function (data) {
      this.analyzeLayerMenuData = data
    },

    /**
     * 凡例用データをセットする
     * @param {Object} legend 凡例用データ
     */
    $_setLegendData: function (legend) {
      this.legend = legend
    },

    /**
     * レイヤー種類選択肢をセットする
     * @param {Array.<Object>} options 選択肢
     */
    $_setLayerOptions: function (options) {
      this.dataMap.options = options
    },

    /**
     * 位置再生コントローラーをセットする
     * @param {VueComponent} controller AppLocationPlayControllerのインスタンス
     */
    $_setPlayController: function (controller) {
      this.play.controller = controller
    },

    /**
     * hover中地物をセットする
     * @param {Object} feature hover中地物
     */
    $_setHoverFeature: function (feature) {
      this.track.hoverFeature = feature
    },

    /**
     * ベースマップ初期化完了時処理
     */
    $_onMapInitEnd: function () {
      this.map = this.$refs['map-control']
    },

    /**
     * レイヤーの表示状態変更イベントの処理
     * @param {Array.<Object>} value 表示状態変更値
     */
    $_onLayerMenuVisibleChanged: function (value) {
      if (this.renderer) {
        const analyzeLayerValue = value.find((v) => v.id === this.renderer.id)
        if (analyzeLayerValue) {
          this.visible.all = analyzeLayerValue.visible
        }
      }
      this.$store.dispatch('map/setVisible', value)
    },

    /**
     * リストビューの表示・非表示を切り替える
     */
    $_toggleListViewShown: function () {
      this.isListViewShown = !this.isListViewShown
    },

    /**
     * モーダル重畳状態変更時処理
     * @param {Boolean} value モーダル重畳状態
     */
    $_onModalOverlayChanged: function (value) {
      this.isModalOverlaid = value
    },

    /**
     * ローディング状態更新
     * @param {Boolean} isLoading ローディング状態
     */
    $_updateLoading: function (isLoading) {
      this.isLoading = isLoading
    },

    /**
     * 対象データが無いアラートを表示
     */
    $_showNoLocationAlert: function () {
      this.$toast.fire({
        icon: 'warning',
        title: this.$t('theAnalyze.message.noLocation'),
        timer: 2000,
        target: this.map.$el,
        position: 'bottom',
      })
    },

    /**
     * プレイス詳細ダイアログを表示する
     * @param {Number} recordId 表示対象のプレイスレコードのID
     */
    $_showPlaceDialog: function (recordId) {
      // ダイアログを表示する
      this.$refs['place-detail'].showModal(recordId)
    },

    /**
     * 報告書ページへ遷移する
     * @param {Array.<Number>} placeIds プレイスID配列
     */
    $_showReport: function (placeIds) {
      this.$router.push({
        name: 'report',
        params: {
          defaultPlaceIds: placeIds,
        },
      })
    },

    /**
     * 地図ページへ遷移する
     * @param {Object} params 遷移時に引き渡すパラメータ
     */
    $_showMember: function (params) {
      this.$router.push({
        name: 'member',
        params,
      })
    },

    /**
     * プレイス詳細非表示時処理
     * @param {Boolean} isUpdated 表示されていたプレイスが更新された場合はtrue
     */
    $_onHidePlaceDetail: function (isUpdated) {
      if (isUpdated) {
        // 地図の強制再描画
        const deck = this.map.getMapDeckController()
        deck && deck.render(true)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../assets/scss/parts/container';

$-tab-height: 40px;

.container-analyze {
  /*  display: -webkit-box !important; */
  display: flexbox !important;
  margin: 0 !important;
  height: 100%;
}

.view-analyze {
  width: 100%;
  height: 100%;
  padding: 8px 10px 0 0 !important;
  box-sizing: border-box;
  background-color: #ffffff;
  transition: 0.3s;
}

.view-map {
  display: -webkit-box !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  overflow: hidden !important;
}

.tab-bar {
  height: $-tab-height;
  display: grid;
  grid-template-columns: 1fr 8px;
  justify-content: space-between;
  align-items: center;
}

.tab-container {
  height: $-tab-height;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1px;
}

.tab-content {
  height: calc(100% - #{$-tab-height});
  border: 1px solid #cfcfcf;
  border-top-right-radius: 8px;
}

.tab {
  width: auto;
  height: $-tab-height;
  margin: 0 0 -1px 0;
  padding: 0 clamp(8px, 4%, 20px);
  background-color: #e9ecef;
  border: 1px solid #cfcfcf;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  font-weight: $font-weight-bold;
  font-size: $font-size-middle;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  user-select: none;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    background-color: #e2e6ea;
  }

  &.active {
    background-color: #ffffff;
    border-bottom-color: #ffffff;
  }
}

#analyze-map-control {
  ::v-deep .control-wrapper {
    &.left-top-wrapper {
      padding-left: 0;
    }
    &.left-bottom-wrapper {
      padding-left: 40px;
    }
  }
}

.map-left-top-container {
  min-height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap-reverse; // ビル表示を上に出すため逆順で折り返す
  column-gap: 8px;
  row-gap: 8px;
  padding-left: 40px;

  .map-control-ui {
    pointer-events: auto;
    ::v-deep &.analyze-layer-type-selector {
      flex: 0 0 200px;
    }
  }
}

.location-play-controller {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translate(-50%);
  // interleaved: false によって UI が deck.gl の canvas （z-index: 999）より背面に配置される問題への対応。
  z-index: 1000;
}

// ローディングマスクの表示/非表示時に不要なホバーイベントを抑制するためマウスイベントを無視
::v-deep .loading-overlay {
  pointer-events: none;
}
</style>
